import SeoJsonLd from '@/components/base/SeoJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedProducts from './components/FeaturedProducts';
import ArticleCards from './components/ArticleCards';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoospreadsheet.team';

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Sugargoo Spreadsheet 2026',
    url: siteUrl,
    description:
      'The largest Sugargoo Spreadsheet resource center featuring curated finds, buying guides, category spreadsheets, safety tips, and shopping tutorials. All traffic funnels to the main website.',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SeoJsonLd data={websiteJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryGrid />
        <FeaturedProducts />
        <ArticleCards />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
}